<form [formGroup]="formGroup">

  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.riskLocationQuestion'|translate}}</h3>
    </div>
    <ng-container formArrayName="riskLocations">
      <ng-container *ngFor="let riskLocation of formGroup.controls.riskLocations.controls; let i = index">
        <div class="d-flex flex-column" [formGroup]="riskLocation">
          <div class="d-flex justify-content-between">
            <h5> {{'createProposal.subtitleRiskLocation'|translate}} {{i + 1}}</h5>
            <button *ngIf="formGroup.controls.riskLocations.length > 1" (click)="deleteForm(i)"
                    class="delete-button h-32"><img
              src="assets/img/form/trashbin.svg"
              alt=""></button>
          </div>
          <app-input-field [control]="riskLocation.controls.description" class="field-container"
                           [label]="'createProposal.locationDescription'|translate">
            <input name="locationDescription+{{i}}" formControlName="description"
                   class="input">
          </app-input-field>
          <div class="d-flex justify-content-between field-container">
            <app-input-field [control]="riskLocation.controls.street" class="bigger-input"
                             [label]="'createProposal.street'|translate">
              <input name="street+{{i}}" formControlName="street" class="input">
            </app-input-field>

            <app-input-field [control]="riskLocation.controls.houseNumber" class="smaller-input"
                             [label]="'createProposal.streetNumber'|translate">
              <input name="streetNumber+{{i}}" formControlName="houseNumber"
                     class="input">
            </app-input-field>
          </div>

          <div class="d-flex justify-content-between field-container">
            <app-input-field [control]="riskLocation.controls.postalCode" class="smaller-input"
                             [label]="'createProposal.postalCode'|translate">
              <input name="postalCode+{{i}}" formControlName="postalCode"
                     type="text"
                     class="input">
            </app-input-field>

            <app-input-field [control]="riskLocation.controls.location" class="bigger-input"
                             [label]="'createProposal.location'|translate">
              <input name="location+{{i}}" formControlName="location" class="input">
            </app-input-field>
          </div>

          <div class="d-flex justify-content-between field-container">
            <app-input-field [control]="riskLocation.controls.countryCode" class="smaller-input"
                             [label]="'createProposal.countryCode'|translate">
              <mat-select formControlName="countryCode"
                          class="input"
                          [value]="riskLocation.value.countryCode" #singleSelect>
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="riskLocationSearchArray[i].filterCtrlCountryCode"
                    ngDefaultControl></ngx-mat-select-search>
                </mat-option>
                <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
                <mat-option *ngFor="let option of riskLocationSearchArray[i].filteredOptionsCountryCode |async"
                            [value]="option">
                  {{option}}
                </mat-option>

              </mat-select>
            </app-input-field>

            <app-input-field [control]="riskLocation.controls.countryCode" class="bigger-input"
                             [label]="'createProposal.country'|translate">
              <mat-select formControlName="countryCode"
                          class="input"
                          [value]="riskLocation.value.countryCode" #singleSelect>
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="riskLocationSearchArray[i].filterCtrlCountry"
                    ngDefaultControl></ngx-mat-select-search>
                </mat-option>
                <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
                <mat-option *ngFor="let option of riskLocationSearchArray[i].filteredOptionsCountry |async"
                            [value]="getCountryCodeFromCountry(option)">
                  {{option}}
                </mat-option>

              </mat-select>
            </app-input-field>
          </div>
        </div>
        <div *ngIf="riskLocation.value.geoLocation && riskLocation.value.street && riskLocation.value.houseNumber && riskLocation.value.location
                    && riskLocation.value.countryCode"
             class="insuredAmountSubtitle geoLocation">
          {{'createProposal.geoLocation'|translate}}{{ riskLocation.value.geoLocation }}
        </div>

        <!-- SkenData button to show form -->
        <div *ngIf="skenDataCredentialsValid && !showSkenDataForm[i]">
          <button id="addSkenDataButton" class="skendata-button" style="float: none; margin-left: 0;"
                  [disabled]="!enableSkenDataButton[i]"
                  (click)="enableShowSkenData(i)">
            <img src="assets/img/skendata/skendata_logo_stripes.png" alt="skendata logo" style="height: 15px; width: auto;">
            {{'createProposal.skenData.showButtonTitle'|translate}}</button>
        </div>

        <!-- SkenData form -->
        <div *ngIf="showSkenDataForm[i]">
          <hr class="line">

          <div class="d-flex flex-column" [formGroup]="riskLocation">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="d-flex align-items-center">
                <h5 class="mb-0">{{ 'createProposal.skenData.sectionTitle' | translate }} - </h5>
                <img src="assets/img/skendata/skendata_logo_full.png" alt="SkenData Logo" style="height: 15px; width: auto; margin-left: 8px;">
              </div>
              <button (click)="deleteSkenDataForm(i)" class="delete-button h-32">
                <img src="assets/img/form/trashbin.svg" alt="Delete">
              </button>
            </div>
            <app-input-field [control]="riskLocation.controls.skenBuildingValue14" class="field-container"
                             [label]="'createProposal.skenData.buildingValue14'|translate">
              <input name="skenBuildingValue14+{{i}}" appNumberFormat formControlName="skenBuildingValue14"
                     class="input">
            </app-input-field>
            <app-input-field [control]="riskLocation.controls.skenTotalValueEur" class="field-container"
                             [label]="'createProposal.skenData.totalValueEur'|translate">
              <input name="skenTotalValueEur+{{i}}" appNumberFormat formControlName="skenTotalValueEur" class="input">
            </app-input-field>
            <app-input-field [control]="riskLocation.controls.skenRegionalizedTotalValueM" class="field-container"
                             [label]="'createProposal.skenData.regionalizedTotalValueM'|translate">
              <input name="skenRegionalizedTotalValueM+{{i}}" appNumberFormat formControlName="skenRegionalizedTotalValueM"
                     class="input">
            </app-input-field>
            <app-input-field [control]="riskLocation.controls.skenRegionalizedTotalValueEur" class="field-container"
                             [label]="'createProposal.skenData.regionalizedTotalValueEur'|translate">
              <input name="skenRegionalizedTotalValueEur+{{i}}" appNumberFormat formControlName="skenRegionalizedTotalValueEur"
                     type="text"
                     class="input">
            </app-input-field>

            <!-- SkenData upload report -->
            <div>
              <button (click)="uploadFile()" id="uploadSkenDataReport" class="add-button" style="float: none; margin-left: 0;">
                <img src="assets/img/skendata/skendata_logo_stripes.png" alt="skendata logo"  style="height: 15px; width: auto;">
                {{'createProposal.skenData.uploadReportButton' | translate}}
              </button>

              <!-- Hidden file input -->
              <input type="file" #fileInput style="display:none" (change)="onFileChange($event)">
            </div>
          </div>
        </div>

        <hr class="line">
      </ng-container>
    </ng-container>

    <div class="d-flex justify-content-start ">
      <button *ngIf="formGroup.controls.riskLocations.length<maxNumber" id="addButton" class="add-button"
              (click)="addForm()">
        + {{'createProposal.addLocation'|translate}}</button>
    </div>
    <div class="mt-3 d-flex flex-column ">
      <span
        class="small-title"> {{'proposalDetails.createOfferTab.fileUploadSection.title'|translate}}</span>
      <div class="d-flex field-container">
        <app-upload
          [uploadLocation]="UploadLocation.RISKLOCATION"
          (updateAttachedFilesInParent)="attachFiles($event)"
          class="w-100"
        ></app-upload>
      </div>
    </div>

  </div>

</form>
